import { FinancialDocumentTypesEnum } from "@/shared/models/enums.type";
import { FinDocLineItemViewModel } from "../FinancialDocumentFormParts/models";

export class InvoiceRoutingInvoiceModel {
    index = 1;

    customerId = null as number | null;
    customerName = "";
    customerOib = "";
    paymentMeansId = null as number | null;
    cardTypeId = null as number | null;

    documentTypeId = FinancialDocumentTypesEnum.Racun;

    items: InvoiceRoutingLineItem[] = [];
    errors: string[] = [];
}

export class InvoiceRoutingLineItem extends FinDocLineItemViewModel {
    propertyId = null as number | null;
    vatCategoryForPrepaymentsId = null as number | null;

    // clientside properties
    isSelected = false;
    isAssigned = false;
    originalTaxRateId = 0;

    businessUnitId: number | null = null;
}

export interface InvoiceRoutingViewModel {
    items: InvoiceRoutingItemViewModel[];
    warnings: string[];
}

export interface InvoiceRoutingItemViewModel {
    lineItem: InvoiceRoutingLineItem,
    propertyId: number | null;
    vatCategoryForPrepaymentsId: number | null;

    businessUnitId: number | null;
}